// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2lcLb","requiredAsterisk":"Info_requiredAsterisk__3t5W9"};